import * as formUtil from '../../util/form-util';
import { IFormMetadataProcessor } from './iFormMetaDataProcessor';
import { FormData } from '../../forms-ui-form-faas.interface';

/*
 * A field can be classified as type = hidden. When that is the case, the form author
 * can specify whether or not they want the value of the field to be pulled from the
 * url query params. For example, if they create a field called 'channel', make it
 * hidden, and set it to read from query params, our form should look for the channel
 * param in the url search query. So https://mastercard.com/mycoolform?channel=Social%20Media
 * would end up with a value of 'Social Media' submitted for the field 'channel' if properly
 * configured in FaaS.
 */
export class PrepopulatedFieldProcessor implements IFormMetadataProcessor {
	process(formMetadata: FormData): Promise<FormData> {
		return new Promise((resolve) => {
			// eslint-disable-next-line no-restricted-syntax
			for (const field of formMetadata.formFields) {
				if (field.queryString) {
					const queryParamValue = formUtil.getSearchParamValueIfExists(field.name);
					const localStorageValue = formUtil.getFaasDataFromLocalStorage(field.name);
					field.defaultText = queryParamValue ?? localStorageValue;
				}
			}
			resolve(formMetadata);
		});
	}
}
